export function Spinner({ size = 16, className = "" }) {
  return (
    <span
      className={`spinner ${className}`}
      style={{ width: size, height: size }}
      role="status"
      aria-label="Loading"
    />
  );
}

export function Loader({ label = "Loading...", inline = false, className = "" }) {
  return (
    <div className={`loader ${inline ? "loader-inline" : ""} ${className}`} role="status">
      <Spinner size={inline ? 14 : 22} />
      {label ? <span className="loader-label">{label}</span> : null}
    </div>
  );
}

export function SkeletonRows({ columns = 1, rows = 5 }) {
  return (
    <>
      {Array.from({ length: rows }).map((_, r) => (
        <tr key={`skeleton-${r}`} className="skeleton-row" aria-hidden="true">
          {Array.from({ length: Math.max(columns, 1) }).map((__, c) => (
            <td key={`skeleton-${r}-${c}`}>
              <span
                className="skeleton-bar"
                style={{ animationDelay: `${(r * columns + c) * 40}ms` }}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}